import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchService } from '../shared/search-elasticsearch.service';
import { UtilsService } from '../shared/utils.service';
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
@Component({
  selector: 'admin-search-facets',
  // template: `
  //     <div *ngFor="let agg of esAggregations | mapToIterable" class="facet">
  //       <div class="facet-title">{{agg.key}}</div>
  //       <ol class="list-unstyled">
  //         <li *ngFor="let term of agg.value.buckets">
  //           <span *ngIf="!utils.isInFilters(esFilters, agg.key, term.key)">
  //             <a (click)="onSelect(agg.key, term.key)" style="cursor: pointer">
  //               {{ term.key | truncate:20 }}
  //             </a> 
  //             <small>({{term.doc_count}})</small>
  //           </span>
  //           <span *ngIf="utils.isInFilters(esFilters, agg.key, term.key)">
  //             {{term.key}} <small>({{term.doc_count}})</small>
  //           </span>
  //         </li>
  //       </ol>
  //     </div>`
  template: require('./partials/search-facets.html')
})
export class AdminSearchFacetsComponent implements OnInit {

  @Input() fields: string[];
  @Input() esAggregations: Object[];
  @Input() esFilters: Object[];
  @Output() onFilter: EventEmitter<Object> = new EventEmitter<Object>();
  private filterQueryParams: string;
  private searchQueryParams: string;

  constructor(private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) {}

  ngOnInit(){
    this.route.queryParams.subscribe(params => {
      this.searchQueryParams = params['s'];
      this.filterQueryParams = params['f'];
    });
  }

  onSelect(type: string, value: string) {
    // Callback 
    this.onFilter.emit({type: type, value: value});
    // Nav
    let newQueryParams = { queryParams: {} };
    // keep current search
    if(this.searchQueryParams)
      newQueryParams.queryParams['s'] = this.searchQueryParams;
    newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
    newQueryParams['relativeTo'] = this.route;
    this.router.navigate(['.'], newQueryParams);
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-search-facets.component.ts